<template>
	<div class="product">
		<div class="banner-container">
			<!-- 背景图 -->
			<banner img="../assets/img/bgtop.jpg" title="产品介绍" />
			<!-- 悬浮文字 -->
			<p class="floating-text">24小时全天侯防护</p>
		</div>
		<div class="image-container">
			<img
				v-for="(image, index) in images"
				:key="'img' + index"
				:data-src="image.src"
				:src="image.loaded ? image.src : placeholder"
				alt="Image"
				class="image-item"
				:class="{ loaded: image.loaded }"
				@load="onImageLoad(index)"
			/>
		</div>
	</div>
</template>

<script>
import Banner from '../components/Banner'

export default {
	data() {
		// 动态加载图片路径
		const imagesContext = require.context(
			'../assets/img/product',
			false,
			/\.(png|jpe?g|svg)$/i
		)
		//const imagePaths = imagesContext.keys().map(imagesContext);
		// 先排序，再映射
		const imagePaths = imagesContext
			.keys()
			.sort((a, b) => {
				const numA = parseInt(a.match(/\/(\d+)\./)[1], 10) || 0
				const numB = parseInt(b.match(/\/(\d+)\./)[1], 10) || 0
				return numA - numB
			})
			.map(imagesContext)
		// 初始化图片数据，包含是否已加载的状态
		const images = imagePaths.map((src) => ({
			src,
			loaded: false, // 初始状态：未加载
		}))

		return {
			images,
			placeholder:
				'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', // 1x1 透明 GIF 占位图
			observer: null, // IntersectionObserver 实例
		}
	},
	components: {
		Banner,
	},
	mounted() {
		// 创建 IntersectionObserver 实例
		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const img = entry.target
						const realSrc = img.dataset.src

						// 加载真实图片
						const imageLoader = new Image()
						imageLoader.src = realSrc
						imageLoader.onload = () => {
							img.src = realSrc
							this.onImageLoad(img.dataset.index) // 更新状态
						}
						// 停止观察该元素
						this.observer.unobserve(img)
					}
				})
			},
			{
				root: null, // 使用视口作为根
				rootMargin: '0px', // 无边距
				threshold: 0.1, // 当 10% 的元素可见时触发
			}
		)

		// 开始观察所有带有 .lazy 类的图片
		this.$nextTick(() => {
			const lazyImages = this.$el.querySelectorAll('.image-item')
			lazyImages.forEach((img, index) => {
				img.dataset.index = index // 为每个图片添加索引
				this.observer.observe(img)
			})
		})
	},
	beforeUnmount() {
		// 组件销毁前，断开观察器以避免内存泄漏
		if (this.observer) {
			this.observer.disconnect()
		}
	},
	methods: {
		onImageLoad(index) {
			// 更新图片加载状态
			this.$set(this.images[index], 'loaded', true) // 使用 $set 确保响应式更新
		},
	},
}
</script>

<style lang="scss" scoped>
.product {
	width: 100%;
	height: 100%;
	background-color: #fff;
}
// banner容器 - 用于定位悬浮文字
.banner-container {
	position: relative; // 相对定位，作为悬浮文字的定位参考
	display: inline-block; // 适应背景图大小
	width: 100%; // 占满宽度
}
// 悬浮文字样式
.floating-text {
	position: absolute; // 绝对定位，相对于banner-container
	right: 120px; // 距离右侧20px，可调整
	top: 50%; // 垂直方向居中
	transform: translateY(-50%); // 精确垂直居中
	margin: 0; // 清除默认margin

	// 文字样式，可根据需要调整
	color: #f1e9e9ff; // 文字颜色，根据背景图调整以确保清晰
	z-index: 10; // 确保文字在背景图上方
}

@media (max-width: 768px) {
	.floating-text {
		width: 100vw;
		text-align: center;
		font-size: 30px;
		font-weight: 400;
		transform: unset;
		right: 0;
		top: 70%;
	}
}

@media (min-width: 768px) and (max-width: 1220px) {
	.floating-text {
		font-size: 3vw;
	}
}
@media (min-width: 1221px) {
	.floating-text {
		font-size: 50px;
	}
}

.image-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
}
@media (max-width: 768px) {
	.image-container {
		> img {
			width: 100vw;
		}
	}
}
.image-item {
	margin: 5px 0;
	// max-height: 80vh;
	opacity: 0.5; // 未加载时半透明
	transition: opacity 0.3s ease-in-out;
}

.image-item.loaded {
	opacity: 1; // 加载完成后恢复正常透明度
}
</style>
